module.exports = __webpack_public_path__ + "img/logo.b75a9274.png";